/** THIS FILE IS AUTOGENERATED. DO NOT EDIT. */
import type { IconProps } from './types/index';

function IcUserguideRegular({ className, ...props }: IconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="currentColor"
      viewBox="0 0 24 24"
      className={`kc-console-icon ${className ? className : ''}`}
      {...props}
    >
      <path d="M20 1.1a.9.9 0 0 1 .9.9v20a.9.9 0 0 1-.9.9H5A1.9 1.9 0 0 1 3.1 21V3A1.9 1.9 0 0 1 5 1.1zM4.9 21a.1.1 0 0 0 .1.1h14.1v-2.2H4.9zM5 2.9a.1.1 0 0 0-.1.1v14.1h14.2V2.9zm7 6.2a.9.9 0 0 1 .9.9v3.6H14v1.8h-4v-1.8h1.1v-2.7h-.6V9.1zm-.25-3.85a1.5 1.5 0 1 1 0 3.001 1.5 1.5 0 0 1 0-3" />
    </svg>
  );
}
export default IcUserguideRegular;
